"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Body_1 = require("./Body");
var buildState_1 = require("./buildState");
var Footer_1 = require("./Footer");
var GroupedBody_1 = require("./GroupedBody");
var Header_1 = require("./Header");
var StyledDataTable_1 = require("./StyledDataTable");
var DataTable = /** @class */ (function (_super) {
    tslib_1.__extends(DataTable, _super);
    function DataTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.onFiltering = function (property) {
            _this.setState({ filtering: property });
        };
        _this.onFilter = function (property, value) {
            /* eslint-disable-next-line react/prop-types */
            var onSearch = _this.props.onSearch;
            var filters = _this.state.filters;
            var nextFilters = tslib_1.__assign({}, filters);
            nextFilters[property] = value;
            _this.setState({ filters: nextFilters });
            // Let caller know about search, if interested
            if (onSearch) {
                onSearch(nextFilters);
            }
        };
        _this.onSort = function (property) { return function () {
            var sort = _this.state.sort;
            var ascending = sort && property === sort.property ? !sort.ascending : true;
            _this.setState({ sort: { property: property, ascending: ascending } });
        }; };
        _this.onToggleGroup = function (groupValue) { return function () {
            var groupState = _this.state.groupState;
            var nextGroupState = tslib_1.__assign({}, groupState);
            nextGroupState[groupValue] = tslib_1.__assign(tslib_1.__assign({}, nextGroupState[groupValue]), { expanded: !nextGroupState[groupValue].expanded });
            _this.setState({ groupState: nextGroupState });
        }; };
        _this.onToggleGroups = function () {
            var groupState = _this.state.groupState;
            var expanded = Object.keys(groupState).filter(function (k) { return !groupState[k].expanded; }).length === 0;
            var nextGroupState = {};
            Object.keys(groupState).forEach(function (k) {
                nextGroupState[k] = tslib_1.__assign(tslib_1.__assign({}, groupState[k]), { expanded: !expanded });
            });
            _this.setState({ groupState: nextGroupState });
        };
        _this.onResize = function (property) { return function (width) {
            var widths = _this.state.widths;
            var nextWidths = tslib_1.__assign({}, (widths || {}));
            nextWidths[property] = width;
            _this.setState({ widths: nextWidths });
        }; };
        return _this;
    }
    DataTable.getDerivedStateFromProps = function (nextProps, prevState) {
        return buildState_1.buildState(nextProps, prevState);
    };
    DataTable.prototype.render = function () {
        var _a = this.props, columns = _a.columns, propsData = _a.data, groupBy = _a.groupBy, onMore = _a.onMore, resizeable = _a.resizeable, size = _a.size, sortable = _a.sortable, onSearch = _a.onSearch, // removing unknown DOM attributes
        rest = tslib_1.__rest(_a, ["columns", "data", "groupBy", "onMore", "resizeable", "size", "sortable", "onSearch"]);
        var _b = this.state, data = _b.data, filtering = _b.filtering, filters = _b.filters, footerValues = _b.footerValues, groups = _b.groups, groupState = _b.groupState, primaryProperty = _b.primaryProperty, showFooter = _b.showFooter, sort = _b.sort, widths = _b.widths;
        if (size && resizeable) {
            console.warn('DataTable cannot combine "size" and "resizeble".');
        }
        return (React.createElement(StyledDataTable_1.StyledDataTable, tslib_1.__assign({}, rest),
            React.createElement(Header_1.Header, { columns: columns, filtering: filtering, filters: filters, groups: groups, groupState: groupState, size: size, sort: sort, widths: widths, onFiltering: this.onFiltering, onFilter: this.onFilter, onResize: resizeable ? this.onResize : undefined, onSort: sortable ? this.onSort : undefined, onToggle: this.onToggleGroups }),
            groups ? (React.createElement(GroupedBody_1.GroupedBody, { columns: columns, groupBy: groupBy, groups: groups, groupState: groupState, primaryProperty: primaryProperty, onToggle: this.onToggleGroup })) : (React.createElement(Body_1.Body, { columns: columns, data: data, onMore: onMore, primaryProperty: primaryProperty, size: size })),
            showFooter && React.createElement(Footer_1.Footer, { columns: columns, footerValues: footerValues, groups: groups, size: size })));
    };
    DataTable.defaultProps = {
        columns: [],
        data: []
    };
    return DataTable;
}(React.Component));
exports.DataTable = DataTable;
//# sourceMappingURL=DataTable.js.map